import styled from 'styled-components';

import { IButton } from './Button';

export const ButtonStyle = styled.button<IButton.IProps>`
   {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    background: ${({ theme, color, isLinear }) =>
      (isLinear && color === 'green' && theme.colors.gray0) ||
      (isLinear && 'transparent') ||
      (color === 'green' && theme.colors.primaryGreen500) ||
      (color === 'red' && theme.colors.red500) ||
      (color === 'white' && theme.colors.gray0) ||
      (color === 'gray' && theme.colors.gray500)};
    flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
    justify-content: center;
    align-items: center;
    padding: ${({ size }) => (size === 'small' && '8px 16px') || '12px 16px'};
    border-radius: 8px;
    opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
    color: ${({ isLinear, color, theme }) =>
      (color === 'white' && theme.colors.primaryGreen500) ||
      (!isLinear && theme.colors.gray0) ||
      (color === 'green' && theme.colors.primaryGreen500) ||
      (color === 'red' && theme.colors.red500) ||
      (color === 'gray' && theme.colors.gray500)};
    font-size: ${({ size }) => (size === 'large' && '18px') || '14px'};
    line-height: ${({ size }) => (size === 'large' && '24px') || '16px'};
    font-weight: 600;
    opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
    width: ${({ fullWidth }) => fullWidth && '100%'};
    display: flex;
    gap: 8px;
    outline: 3px solid transparent;
    border: ${({ isLinear }) => (isLinear ? `1.5px solid ` : '1.5px solid transparent')};
    border-color: ${({ color, theme }) =>
      (color === 'green' && theme.colors.primaryGreen500) ||
      (color === 'red' && theme.colors.red500) ||
      (color === 'gray' && theme.colors.gray500)};

    &:hover {
      box-sizing: border-box;
      outline-color: ${({ theme, color }) =>
        (color === 'green' && theme.colors.primaryGreen200) ||
        (color === 'red' && theme.colors.red200) ||
        theme.colors.gray200};
    }

    &:active {
      outline-color: transparent;
      background-color: ${({ theme, color, isLinear }) =>
        (isLinear && color === 'green' && theme.colors.primaryGreen100) ||
        (isLinear && color === 'red' && theme.colors.red100) ||
        (isLinear && color === 'gray' && theme.colors.gray100) ||
        (color === 'green' && theme.colors.primaryGreen600) ||
        (color === 'red' && theme.colors.red600) ||
        (color === 'gray' && theme.colors.gray600)};
    }
  }
`;

export const Spinner = styled.div`
  border: 2px solid ${({ theme }) => theme.colors.gray50};
  border-radius: 50%;
  border-top: 2px solid ${({ theme }) => theme.colors.primaryGreen500};
  width: 16px;
  height: 16px;
  -webkit-animation: spin 1.5s linear infinite; /* Safari */
  animation: spin 1.5s linear infinite;
  /* Safari */
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
